import { FC } from 'react';
import { ScoreCalculationTooltipBody, ScoreCalculationTooltipBodyProps } from './components';
import { TooltipProps, Tooltip } from '../Tooltip';
import { isBeachModeElement } from '../../../Scorecard';

export interface ScoreCalculationTooltipProps
  extends Pick<TooltipProps, 'shouldHide' | 'offset'>,
    ScoreCalculationTooltipBodyProps {
  children?: React.ReactNode;
  beachMode?: boolean;
}

export const ScoreCalculationTooltip: FC<ScoreCalculationTooltipProps> = ({
  offset,
  score,
  element,
  children,
  calculationScorecardValues,
  beachMode,
  ...tooltipProps
}) => {
  const beachModeElement = beachMode && isBeachModeElement(element);

  return (
    <Tooltip
      placement={beachModeElement ? 'left' : 'top'}
      {...tooltipProps}
      offset={offset || (beachModeElement ? [14, 3] : [-14, 3])}
      floatingElement={
        <ScoreCalculationTooltipBody
          beachMode={beachMode}
          score={score}
          element={element}
          calculationScorecardValues={calculationScorecardValues}
        />
      }
    >
      {children}
    </Tooltip>
  );
};
